module.exports = __webpack_public_path__ + "static/media/control_entre_carga3.7c4a5386.svg";